webpackJsonp([63157598966281],{

/***/ 1404:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CreateStockTransferFulfillmentItemInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"expirationDate","type":{"kind":"SCALAR","name":"Date","ofType":null}},{"defaultValue":null,"description":null,"name":"fulfillmentNote","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"lotNumber","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"quantityChangeReason","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"receivedQuantity","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"defaultValue":null,"description":null,"name":"status","type":{"kind":"ENUM","name":"StockTransferFulfillmentItemStatus","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-create-stock-transfer-fulfillment-item-input-6c7ed522dd9628b9efe4.js